import { useLang } from "@/lib/i18n";
import { PageHead } from "@/components/Ui";
import { LeadForm } from "@/components/Forms";

export default function Demo() {
  const { t } = useLang();
  return (
    <div className="bg-grid" data-testid="demo-page">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <PageHead eyebrow={t("demo.eyebrow")} title={t("demo.title")} sub={t("demo.sub")} testid="demo-head" />
        <div className="mt-10">
          <LeadForm endpoint="/demo-requests" withDemoFields testid="demo-form" />
        </div>
      </div>
    </div>
  );
}
